module.exports = __webpack_public_path__ + "media/images/sp/stores/common/appeal_01-9f9da86ae71a7162e0fe7c46d23bcc8d.jpg";